import { Table } from '../../Table';
import React from 'react';
import useTable from '../../../hooks/useTable';
import { TableComponentProps } from '../types';

const columnLables = {
  aifm_national_code: {
    name: "Your national regulator's code for you as a fund manager (FRN)",
    order: 1,
    disabled: true,
    letter: 'A'
  },
  aif_national_code: {
    name: 'Fund national authority code (PRN)',
    order: 2,
    disabled: true,
    letter: 'A'
  },
  aif_domicile: {
    name: 'Current domicile',
    order: 3,
    letter: 'A'
  },
  aif_name: {
    name: 'Fund name',
    order: 5,
    letter: 'A'
  }
};

export const BasicTable = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.FUND_INFOS,
    onChangeFund,
    schema: schema.FUND_INFOS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.FUND_INFOS?.field_names || [],
    isMultiFunds,
    funds,
    tableName: 'FUND_INFOS',
    columnLables
  });

  return (
    <Table
      id="fca-reporttables-basic-table"
      handleChanges={onChange}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      columns={columns}
      rows={rows}
    />
  );
};
